import React, { useContext, useEffect, useState, useRef } from 'react'
import StudentContext from '../../context/StudentContext'
import Sidedash from '../uicomponents/Sidedash'
import useStudentData from '../students/Usestudentdata'
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';
import { convertSlotToTimings } from '../utils/Utilsfunc'
import { DateRange } from 'react-date-range';
import { addDays } from 'date-fns';
import { useSettings } from '../../context/SettingsContext';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

const Profile = () => {
  const context = useContext(StudentContext)
  const { getOneStudent } = context;
  const [show, setShow] = useState(false);
  const [selectedSeats, setSelectedSeats] = useState({});
  const navigate = useNavigate();
  const { studentData, error } = useStudentData(getOneStudent);
  const { settings } = useSettings();
  const [attendanceData, setAttendanceData] = useState([]);
  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: 'selection'
    }
  ]);
  const [loading, setLoading] = useState(false);
  const [attendanceError, setAttendanceError] = useState(null);
  const [showCalendar, setShowCalendar] = useState(false);
  const [showNoSeatsAlert, setShowNoSeatsAlert] = useState(true);
  const calendarRef = useRef(null);
  const host = process.env.REACT_APP_BACKEND_URL || '';

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  // Calculate available hours between check-in and check-out times
  const calculateAvailableHours = (checkInTimes, checkOutTimes) => {
    let totalHours = 0;
    for (let i = 0; i < checkInTimes.length; i++) {
      if (i < checkOutTimes.length) {
        const checkIn = new Date(checkInTimes[i].time);
        const checkOut = new Date(checkOutTimes[i].time);
        const diffHours = (checkOut - checkIn) / (1000 * 60 * 60);
        totalHours += diffHours;
      }
    }
    return totalHours.toFixed(2);
  };

  const fetchAttendanceData = async () => {
    setShowCalendar(false);
    try {
      setLoading(true);
      setAttendanceError(null);
      const params = new URLSearchParams({
        startDate: dateRange[0].startDate.toISOString(),
        endDate: dateRange[0].endDate.toISOString(),
      });
      const res = await fetch(`${host}/attendance/range?${params}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'auth-token': localStorage.getItem('token'),
        },
      });
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      const data = await res.json();
      // Filter attendance data for the current user only
      const userAttendance = data.filter(entry => entry.studentId._id === studentData._id);
      setAttendanceData(userAttendance);
    } catch (error) {
      console.error('Error fetching attendance data:', error);
      setAttendanceError(`Failed to fetch attendance data: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setShowCalendar(false);
      }
    };

    if (showCalendar) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showCalendar]);

  if (error) return <div>Error: {error}</div>;
  if (!studentData) return <div>No student data found</div>;
  const hasSeatBooking = studentData.seatAssigned && studentData.seatAssigned.length > 0;
  const showRenewBookingButton = hasSeatBooking && !settings?.hideRenewBookingButton;
  const showBookSeatNowButton = !hasSeatBooking && !settings?.hideBookSeatNowButton;

  //gets random avatars
  const avatarFilename = studentData.avatar;
  const handleCheckboxChange = (seatId) => {
    setSelectedSeats(prev => ({
      ...prev,
      [seatId]: !prev[seatId]  // Toggle the checked state
    }));
  };
  const handleSubmit = () => {
    // Include both selected and unselected seats in the navigation state
    const seatAssignments = studentData.seatAssigned.map(seat => ({
      ...seat,
      selected: !!selectedSeats[`${seat.seatNumber}-${seat.slot}`]  // Ensure to initialize selectedSeats state appropriately
    }));

    // Determine which slots are not booked
    const bookedSlots = new Set(studentData.seatAssigned.map(seat => seat.slot));
    const allSlots = ["morning", "afternoon", "evening", "night"];
    const availableSlots = allSlots.filter(slot => !bookedSlots.has(slot)).map(slot => ({
      seatNumber: "New",  // or any logic to assign seat number or keep it flexible
      slot: slot,
      selected: false  // These are not selected by default
    }));

    navigate('/cart', { state: { seatsToRenew: seatAssignments, availableSlots } });
    handleClose();
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <Sidedash />
          <div className="col-md-9 pt-3 pb-5">
            <div className="row">
              <div className="col-12">
                <h2 className="mb-4">My Profile</h2>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                {/* Profile Header Card */}
                <div className="card shadow-sm mb-4" style={{ borderRadius: "16px", border: "none" }}>
                  <div className="row g-0">
                    <div className="col-lg-4 gradient-custom text-center text-white d-flex flex-column align-items-center justify-content-center p-5"
                      style={{ borderTopLeftRadius: '16px', borderBottomLeftRadius: '16px', minHeight: '400px' }}
                    >
                      <div className="position-relative mb-4">
                        <img src={`/images/${avatarFilename}.jpg`}
                          alt="Avatar" 
                          className="rounded-circle shadow" 
                          style={{ width: "150px", height: "150px", objectFit: "cover", border: "5px solid rgba(255,255,255,0.3)" }} />
                      </div>
                      <h5 className="mb-2">{studentData.name}</h5>
                      <div className="mb-3">
                        <span className="badge bg-white text-dark px-3 py-2 rounded-pill">
                          {(studentData.role === "Admin" || studentData.role === "Superadmin") ? studentData.role : "Student"}
                        </span>
                      </div>
                      <div className="bg-white bg-opacity-25 rounded-3 px-4 py-2 mb-3">
                        <small className="d-block mb-1 opacity-75">User ID</small>
                        <h6 className='font-monospace mb-0'>{studentData.uid}</h6>
                      </div>
                      <div className="bg-white bg-opacity-25 rounded-3 px-4 py-2">
                        <small className="d-block mb-1 opacity-75">Attendance Code</small>
                        <h6 className='font-monospace mb-0'>{studentData.attendanceCode}</h6>
                      </div>
                    </div>
                    <div className="col-lg-8">
                      <div className="p-4 p-lg-5" style={{ backgroundColor: "#e6e6e6" }}>

                        {/* Personal Information */}
                        <div className="mb-4">
                          <h6 className="mb-3 d-flex align-items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-person-badge me-2" viewBox="0 0 16 16">
                              <path d="M6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>
                              <path d="M4.5 0A2.5 2.5 0 0 0 2 2.5V14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2.5A2.5 2.5 0 0 0 11.5 0zM3 2.5A1.5 1.5 0 0 1 4.5 1h7A1.5 1.5 0 0 1 13 2.5v10.795a4.2 4.2 0 0 0-.776-.492C11.392 12.387 10.063 12 8 12s-3.392.387-4.224.803a4.2 4.2 0 0 0-.776.492z"/>
                            </svg>
                            Personal Information
                          </h6>
                          <div className="row g-3">
                            <div className="col-md-6">
                              <div className="p-3 bg-light rounded-3">
                                <small className="text-muted d-block mb-1">Email Address</small>
                                <p className="mb-0 text-dark">{studentData.email}</p>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="p-3 bg-light rounded-3">
                                <small className="text-muted d-block mb-1">User ID</small>
                                <p className="mb-0 text-dark font-monospace">{studentData.uid}</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Contact Information */}
                        <div className="mb-4">
                          <h6 className="mb-3 d-flex align-items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-telephone me-2" viewBox="0 0 16 16">
                              <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"/>
                            </svg>
                            Contact Details
                          </h6>
                          <div className="row g-3">
                            <div className="col-md-6">
                              <div className="p-3 bg-light rounded-3">
                                <small className="text-muted d-block mb-1">Primary Phone</small>
                                <p className="mb-0 text-dark">{studentData.phone}</p>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="p-3 bg-light rounded-3">
                                <small className="text-muted d-block mb-1">Alternate Number</small>
                                <p className="mb-0 text-dark">{studentData.parentsphone}</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Other Details */}
                        <div className="mb-4">
                          <h6 className="mb-3 d-flex align-items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-info-circle me-2" viewBox="0 0 16 16">
                              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                              <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                            </svg>
                            Additional Information
                          </h6>
                          <div className="row g-3">
                            <div className="col-md-6">
                              <div className="p-3 bg-light rounded-3">
                                <small className="text-muted d-block mb-1">Address</small>
                                <p className="mb-0 text-dark">{studentData.address}</p>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="p-3 bg-light rounded-3">
                                <small className="text-muted d-block mb-1">Documents</small>
                                <p className="mb-0">
                                  <Link target="_blank" rel="noopener noreferrer" to={studentData.photo} className="text-decoration-none me-3">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-image me-1" viewBox="0 0 16 16">
                                      <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"/>
                                      <path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1z"/>
                                    </svg>
                                    Photo
                                  </Link>
                                  <Link target="_blank" rel="noopener noreferrer" to={studentData.documentid} className="text-decoration-none">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-file-earmark-text me-1" viewBox="0 0 16 16">
                                      <path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5"/>
                                      <path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"/>
                                    </svg>
                                    Document
                                  </Link>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Seat Details */}
                        <div className="mb-4">
                          <h6 className="mb-3 d-flex align-items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-grid-3x3 me-2" viewBox="0 0 16 16">
                              <path d="M0 1.5A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5v13a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5zM1.5 1a.5.5 0 0 0-.5.5V5h4V1zM5 6H1v4h4zm1 4h4V6H6zm-1 1H1v3.5a.5.5 0 0 0 .5.5H5zm1 0v4h4v-4zm5 0v4h3.5a.5.5 0 0 0 .5-.5V11zm0-1h4V6h-4zm0-5h4V1.5a.5.5 0 0 0-.5-.5H11zm-1 0V1H6v4z"/>
                            </svg>
                            Seat Bookings
                          </h6>
                          {
                            studentData.seatAssigned && studentData.seatAssigned.length > 0 ? (
                              <div className="row g-3 mb-3">
                                {studentData.seatAssigned.map((shift, index) => {
                                  const isExpired = (new Date(shift.validityDate)) < (new Date().setHours(0, 0, 0, 0));
                                  return (
                                    <div key={shift.slot} className="col-md-6">
                                      <div className={`p-3 rounded-3 border-2 ${isExpired ? 'border-danger bg-danger bg-opacity-10' : 'border-success bg-success bg-opacity-10'}`} style={{ border: '2px solid' }}>
                                        <div className="d-flex justify-content-between align-items-start mb-2">
                                          <div>
                                            <span className="badge bg-primary px-3 py-2 mb-2">Seat {shift.seatNumber}</span>
                                          </div>
                                          {isExpired && <span className="badge bg-danger">Expired</span>}
                                        </div>
                                        <div className="mb-1">
                                          <small className="text-muted d-block">Time Slot</small>
                                          <p className={`mb-0 ${isExpired ? 'text-danger' : 'text-success'}`}>
                                            {convertSlotToTimings(shift.slot)}
                                          </p>
                                        </div>
                                        <div>
                                          <small className="text-muted d-block">Valid Until</small>
                                          <p className={`mb-0 ${isExpired ? 'text-danger' : 'text-dark'}`}>
                                            {shift.validityDate}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            ) : (
                              showNoSeatsAlert && (
                                <div className="alert alert-info alert-dismissible fade show" role="alert">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-info-circle me-2" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                                  </svg>
                                  No seat bookings found. Book your seat now!
                                  <button type="button" className="btn-close" onClick={() => setShowNoSeatsAlert(false)} aria-label="Close"></button>
                                </div>
                              )
                            )
                          }
                          <div className='d-flex gap-2'>
                            {showRenewBookingButton ? (
                              <button onClick={handleShow} className="btn btn-primary px-4 py-2 rounded-3">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-clockwise me-2" viewBox="0 0 16 16">
                                  <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"/>
                                  <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466"/>
                                </svg>
                                Renew Booking
                              </button>
                            ) : null
                            }
                            {showBookSeatNowButton ? (
                              <button onClick={handleSubmit} className="btn btn-primary px-4 py-2 rounded-3">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-plus-circle me-2" viewBox="0 0 16 16">
                                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
                                </svg>
                                Book a Seat Now!
                              </button>
                            ) : null
                            }
                          </div>
                        </div>

                        {/* Attendance Records */}
                        <div className="mb-4">
                          <h6 className="mb-4 d-flex align-items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-calendar-check me-2" viewBox="0 0 16 16">
                              <path d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0"/>
                              <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"/>
                            </svg>
                            Attendance Records
                          </h6>

                          {/* Date range picker and fetch button */}
                          <div className="row mb-4">
                            <div className="col-md-12">
                              <div className="d-flex align-items-center gap-3 flex-wrap">
                                <div className="position-relative" ref={calendarRef} style={{ minWidth: '280px' }}>
                                  <div className="input-group" style={{ height: '44px' }}>
                                    <span
                                      className="input-group-text bg-white border-end-0 rounded-start-3 mb-3"
                                      style={{ cursor: 'pointer', height: '100%', display: 'flex', alignItems: 'center' }}
                                      onClick={() => setShowCalendar(true)}
                                    >
                                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-calendar2-event" viewBox="0 0 16 16">
                                        <path d="M11 7.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5z" />
                                        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z" />
                                        <path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5z" />
                                      </svg>
                                    </span>
                                    <input
                                      type="text"
                                      readOnly
                                      className="form-control border-start-0 rounded-end-3"
                                      style={{ cursor: 'pointer' }}
                                      onClick={() => setShowCalendar(true)}
                                      value={`${dateRange[0].startDate.toLocaleDateString('en-IN', { timeZone: 'Asia/Kolkata' })} - ${dateRange[0].endDate.toLocaleDateString('en-IN', { timeZone: 'Asia/Kolkata' })}`}
                                    />
                                  </div>
                                  {showCalendar && (
                                    <div className="position-absolute bg-white border rounded-3 p-2 mt-1 shadow-lg" style={{ zIndex: 1000 }}>
                                      <DateRange
                                        onChange={item => {
                                          setDateRange([item.selection]);
                                        }}
                                        moveRangeOnFirstSelection={false}
                                        ranges={dateRange}
                                        rangeColors={["#0d6efd"]}
                                      />
                                    </div>
                                  )}
                                </div>
                                <button
                                  className="btn btn-primary px-4 py-2 rounded-3 mb-0"
                                  onClick={fetchAttendanceData}
                                  disabled={loading}
                                >
                                  {loading ? (
                                    <>
                                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                      Loading...
                                    </>
                                  ) : (
                                    <>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search me-2" viewBox="0 0 16 16">
                                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
                                      </svg>
                                      Check Attendance
                                    </>
                                  )}
                                </button>
                              </div>
                            </div>
                          </div>

                          {attendanceError && (
                            <div className="alert alert-danger rounded-3" role="alert">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-exclamation-triangle me-2" viewBox="0 0 16 16">
                                <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.15.15 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.2.2 0 0 1-.054.06.1.1 0 0 1-.066.017H1.146a.1.1 0 0 1-.066-.017.2.2 0 0 1-.054-.06.18.18 0 0 1 .002-.183L7.884 2.073a.15.15 0 0 1 .054-.057m1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767z"/>
                                <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z"/>
                              </svg>
                              {attendanceError}
                            </div>
                          )}

                          <div className="table-responsive">
                            <table className="table table-hover align-middle">
                              <thead className="table-light">
                                <tr>
                                  <th>Date</th>
                                  <th>Check In</th>
                                  <th>Check Out</th>
                                  <th>Hours</th>
                                  <th>Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                {attendanceData.length > 0 ? (
                                  attendanceData.map((row, index) => (
                                    <tr key={index}>
                                      <td>{new Date(row.date).toLocaleDateString('en-IN', { timeZone: 'Asia/Kolkata' })}</td>
                                      <td>
                                        {row.checkInTimes
                                          .map(entry => new Date(entry.time)
                                            .toLocaleTimeString('en-IN', { timeZone: 'Asia/Kolkata', hour12: true }))
                                          .join(', ')}
                                      </td>
                                      <td>
                                        {row.checkOutTimes
                                          .map(entry => entry.time ?
                                            new Date(entry.time)
                                              .toLocaleTimeString('en-IN', { timeZone: 'Asia/Kolkata', hour12: true })
                                            : 'Not checked out')
                                          .join(', ')}
                                      </td>
                                      <td>{calculateAvailableHours(row.checkInTimes, row.checkOutTimes)} hrs</td>
                                      <td>
                                        {row.checkOutTimes.length >= row.checkInTimes.length ? (
                                          <span className="badge bg-success rounded-pill px-3 py-2">Checked Out</span>
                                        ) : (
                                          <span className="badge bg-warning text-dark rounded-pill px-3 py-2">Available</span>
                                        )}
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan="5" className="text-center text-muted py-4">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" className="bi bi-inbox mb-3 opacity-50" viewBox="0 0 16 16">
                                        <path d="M4.98 4a.5.5 0 0 0-.39.188L1.54 8H6a.5.5 0 0 1 .5.5 1.5 1.5 0 1 0 3 0A.5.5 0 0 1 10 8h4.46l-3.05-3.812A.5.5 0 0 0 11.02 4zm-1.17-.437A1.5 1.5 0 0 1 4.98 3h6.04a1.5 1.5 0 0 1 1.17.563l3.7 4.625a.5.5 0 0 1 .106.374l-.39 3.124A1.5 1.5 0 0 1 14.117 13H1.883a1.5 1.5 0 0 1-1.489-1.314l-.39-3.124a.5.5 0 0 1 .106-.374z"/>
                                      </svg>
                                      <p className="mb-0">No attendance records found. Select a date range and click "Check Attendance".</p>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      <div className={show ? "modal fade show" : "modal fade"} style={{ display: show ? "block" : "none" }} tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content rounded-4 border-0 shadow-lg">
            <div className="modal-header border-0 pb-0">
              <h5 className="modal-title">Select Slots to Renew</h5>
              <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"></button>
            </div>
            <div className="modal-body pt-2">
              <p className="text-muted mb-3">Choose which seat bookings you want to renew:</p>
              <div className="list-group">
                {studentData.seatAssigned && studentData.seatAssigned.map((seat, index) => {
                  const isExpired = new Date(seat.validityDate) < new Date().setHours(0, 0, 0, 0);
                  return (
                    <label key={`${seat.seatNumber}-${seat.slot}`} className="list-group-item d-flex align-items-center p-3 border rounded-3 mb-2" style={{ cursor: 'pointer' }}>
                      <input
                        className="form-check-input me-3 flex-shrink-0"
                        type="checkbox"
                        checked={!!selectedSeats[`${seat.seatNumber}-${seat.slot}`]}
                        onChange={() => handleCheckboxChange(`${seat.seatNumber}-${seat.slot}`)}
                        id={`custom-checkbox-${index}`}
                      />
                      <div className="flex-grow-1">
                        <div className="d-flex align-items-center gap-2 mb-1">
                          <span className="badge bg-primary">Seat {seat.seatNumber}</span>
                          <span className="badge bg-success">{convertSlotToTimings(seat.slot)}</span>
                          {isExpired && <span className="badge bg-danger">Expired</span>}
                        </div>
                        <small className="text-muted">Valid until: {seat.validityDate}</small>
                      </div>
                    </label>
                  );
                })}
              </div>
            </div>
            <div className="modal-footer border-0">
              <button type="button" className="btn btn-secondary rounded-3" onClick={handleClose}>Cancel</button>
              <button onClick={handleSubmit} type="button" className="btn btn-primary rounded-3 px-4">Proceed to Renew</button>
            </div>
          </div>
        </div>
      </div>
      {show && <div className="modal-backdrop fade show"></div>}
    </>
  )
}

export default Profile